import { Outlet } from "react-router-dom";

import { FilterSubscriptionProvider } from "./filter-subscription/filter-subscription.context";
import './subscription.scss';

export function Subscription() {
  return (
    <div id="ShellSubscription" className="subscription">
       <FilterSubscriptionProvider>
        <Outlet />
      </FilterSubscriptionProvider>
    </div>
  );
}

export default Subscription;
